export default {
  lang_name: '한국어',

  // Tabs
  tab_mine: '채굴',
  tab_upgrade: '강화',
  tab_prestige: '환생',
  tab_achievement: '업적',
  tab_settings: '설정',

  // HUD
  hud_cps: '/s',
  hud_tap: '/tap',
  hud_combo: 'x',

  // Main screen - actions
  action_daily_bonus: '일일보너스',
  action_turbo: '터보',
  action_ad_boost: '광고 부스트',

  // Generator names (fallback i18n keys mapped from config id)
  gen_gen1: '스마트폰 채굴',
  gen_gen2: '노트북 채굴',
  gen_gen3: '데스크탑 채굴',
  gen_gen4: 'GPU 리그',
  gen_gen5: 'ASIC 채굴기',
  gen_gen6: '채굴 농장',
  gen_gen7: '데이터센터',
  gen_gen8: '양자컴퓨터',
  gen_gen9: 'AI 채굴봇',
  gen_gen10: '위성 채굴기',
  gen_gen11: '달 채굴 기지',
  gen_gen12: '은하 채굴 네트워크',

  // Generator themes
  gen_gen1_theme: '주머니 속 부업',
  gen_gen2_theme: '카페 코인 농부',
  gen_gen3_theme: 'PC방 알바',
  gen_gen4_theme: '그래픽카드 대란',
  gen_gen5_theme: '전문 장비',
  gen_gen6_theme: '컨테이너 농장',
  gen_gen7_theme: '기업급 인프라',
  gen_gen8_theme: '미래 기술',
  gen_gen9_theme: '자율 채굴',
  gen_gen10_theme: '우주 확장',
  gen_gen11_theme: '달 정복',
  gen_gen12_theme: '우주 지배',

  // Locked
  locked: '잠김',

  // Upgrade categories
  upg_cat_generator: '생산기 업그레이드',
  upg_cat_global: '글로벌 업그레이드',
  upg_cat_research: '연구',
  upg_cat_darkpool: '다크풀',
  upg_empty: '업그레이드가 아직 해금되지 않았습니다',
  upg_empty_hint: '생산기를 구매하면 업그레이드가 나타납니다',

  // Upgrade names (mapped from config id)
  // Generator upgrades: up_{genId}_t{1,2,3}
  upg_up_gen1_t1: '스마트폰 효율화', upg_up_gen1_t1_desc: '스마트폰 채굴 효율 2배',
  upg_up_gen1_t2: '스마트폰 특화', upg_up_gen1_t2_desc: '스마트폰 채굴 효율 2배',
  upg_up_gen1_t3: '스마트폰 마스터', upg_up_gen1_t3_desc: '스마트폰 채굴 효율 2배',
  upg_up_gen2_t1: '노트북 효율화', upg_up_gen2_t1_desc: '노트북 채굴 효율 2배',
  upg_up_gen2_t2: '노트북 특화', upg_up_gen2_t2_desc: '노트북 채굴 효율 2배',
  upg_up_gen2_t3: '노트북 마스터', upg_up_gen2_t3_desc: '노트북 채굴 효율 2배',
  upg_up_gen3_t1: '데스크탑 효율화', upg_up_gen3_t1_desc: '데스크탑 채굴 효율 2배',
  upg_up_gen3_t2: '데스크탑 특화', upg_up_gen3_t2_desc: '데스크탑 채굴 효율 2배',
  upg_up_gen3_t3: '데스크탑 마스터', upg_up_gen3_t3_desc: '데스크탑 채굴 효율 2배',
  upg_up_gen4_t1: 'GPU 효율화', upg_up_gen4_t1_desc: 'GPU 채굴 효율 2배',
  upg_up_gen4_t2: 'GPU 특화', upg_up_gen4_t2_desc: 'GPU 채굴 효율 2배',
  upg_up_gen4_t3: 'GPU 마스터', upg_up_gen4_t3_desc: 'GPU 채굴 효율 2배',
  upg_up_gen5_t1: 'ASIC 효율화', upg_up_gen5_t1_desc: 'ASIC 채굴 효율 2배',
  upg_up_gen5_t2: 'ASIC 특화', upg_up_gen5_t2_desc: 'ASIC 채굴 효율 2배',
  upg_up_gen5_t3: 'ASIC 마스터', upg_up_gen5_t3_desc: 'ASIC 채굴 효율 2배',
  upg_up_gen6_t1: '농장 효율화', upg_up_gen6_t1_desc: '농장 채굴 효율 2배',
  upg_up_gen6_t2: '농장 특화', upg_up_gen6_t2_desc: '농장 채굴 효율 2배',
  upg_up_gen6_t3: '농장 마스터', upg_up_gen6_t3_desc: '농장 채굴 효율 2배',
  upg_up_gen7_t1: '데이터센터 효율화', upg_up_gen7_t1_desc: '데이터센터 채굴 효율 2배',
  upg_up_gen7_t2: '데이터센터 특화', upg_up_gen7_t2_desc: '데이터센터 채굴 효율 2배',
  upg_up_gen7_t3: '데이터센터 마스터', upg_up_gen7_t3_desc: '데이터센터 채굴 효율 2배',
  upg_up_gen8_t1: '양자컴퓨터 효율화', upg_up_gen8_t1_desc: '양자컴퓨터 채굴 효율 2배',
  upg_up_gen8_t2: '양자컴퓨터 특화', upg_up_gen8_t2_desc: '양자컴퓨터 채굴 효율 2배',
  upg_up_gen8_t3: '양자컴퓨터 마스터', upg_up_gen8_t3_desc: '양자컴퓨터 채굴 효율 2배',
  upg_up_gen9_t1: 'AI봇 효율화', upg_up_gen9_t1_desc: 'AI봇 채굴 효율 2배',
  upg_up_gen9_t2: 'AI봇 특화', upg_up_gen9_t2_desc: 'AI봇 채굴 효율 2배',
  upg_up_gen9_t3: 'AI봇 마스터', upg_up_gen9_t3_desc: 'AI봇 채굴 효율 2배',
  upg_up_gen10_t1: '위성 효율화', upg_up_gen10_t1_desc: '위성 채굴 효율 2배',
  upg_up_gen10_t2: '위성 특화', upg_up_gen10_t2_desc: '위성 채굴 효율 2배',
  upg_up_gen10_t3: '위성 마스터', upg_up_gen10_t3_desc: '위성 채굴 효율 2배',
  upg_up_gen11_t1: '달기지 효율화', upg_up_gen11_t1_desc: '달기지 채굴 효율 2배',
  upg_up_gen11_t2: '달기지 특화', upg_up_gen11_t2_desc: '달기지 채굴 효율 2배',
  upg_up_gen11_t3: '달기지 마스터', upg_up_gen11_t3_desc: '달기지 채굴 효율 2배',
  upg_up_gen12_t1: '은하 효율화', upg_up_gen12_t1_desc: '은하 채굴 효율 2배',
  upg_up_gen12_t2: '은하 특화', upg_up_gen12_t2_desc: '은하 채굴 효율 2배',
  upg_up_gen12_t3: '은하 마스터', upg_up_gen12_t3_desc: '은하 채굴 효율 2배',

  // Global upgrades
  upg_up_global_click1: '강화 손가락', upg_up_global_click1_desc: '탭 파워 x2',
  upg_up_global_click2: '사이보그 손가락', upg_up_global_click2_desc: '탭 파워 x3',
  upg_up_global_cps1: '오버클럭', upg_up_global_cps1_desc: '전체 자동 수입 +50%',
  upg_up_global_cps2: '극한 오버클럭', upg_up_global_cps2_desc: '전체 자동 수입 x2',
  upg_up_global_golden1: '행운의 안테나', upg_up_global_golden1_desc: '골든 이벤트 지속시간 +50%',
  upg_up_global_golden2: '골든 자석', upg_up_global_golden2_desc: '골든 이벤트 출현 빈도 2배',
  upg_up_global_offline: '자동 채굴 최적화', upg_up_global_offline_desc: '오프라인 수익률 50% -> 75%',
  upg_up_global_combo: '콤보 지속 강화', upg_up_global_combo_desc: '콤보 유지 시간 3초 -> 5초',

  // Research upgrades
  upg_up_res_synergy: '시너지 알고리즘', upg_up_res_synergy_desc: '보유 생산기 종류당 자동 수입 +10%',
  upg_up_res_quantum: '양자 가속', upg_up_res_quantum_desc: '전체 자동 수입 x3',
  upg_up_res_ai_click: 'AI 클릭 보조', upg_up_res_ai_click_desc: '탭 파워 x5',
  upg_up_res_golden_master: '골든 마스터', upg_up_res_golden_master_desc: '골든 이벤트 효과 2배 + 지속시간 2배',
  upg_up_res_prestige_boost: '환생 촉진제', upg_up_res_prestige_boost_desc: '환생 시 블록체인 +50% 추가 획득',
  upg_up_res_combo_max: '콤보 브레이커', upg_up_res_combo_max_desc: '최대 콤보 배율 2배 -> 3배',

  // Dark Pool upgrades
  upg_up_dp_scam_promo: '스캠 코인 홍보', upg_up_dp_scam_promo_desc: '다크풀 보상 x2',
  upg_up_dp_insider_net: '인사이더 네트워크', upg_up_dp_insider_net_desc: '내부자 정보 정확도 80% -> 95%',
  upg_up_dp_chip_laundry: '고액 베팅', upg_up_dp_chip_laundry_desc: '최대 베팅 비율 25% → 50%',
  upg_up_dp_whale_ctrl: '고래 조종', upg_up_dp_whale_ctrl_desc: '8x, 12x 배율 확률 대폭 증가',

  // Prestige - Blockchain
  prestige_blockchain_title: '블록체인 환생',
  prestige_blockchain_held: '보유',
  prestige_blockchain_bonus: '보너스',
  prestige_count: '환생 횟수',
  prestige_count_unit: '회',
  prestige_gain: '환생 시',
  prestige_blockchain: '블록체인',
  prestige_execute: '환생하기',
  prestige_need: '총 생산량 1M 이상 필요',
  prestige_current: '현재',

  // Prestige - Buffs
  prestige_buff_title: '블록체인 버프',
  prestige_buff_level: 'Lv.',

  // Prestige buff names
  buff_click: '클릭 파워 증폭',
  buff_click_desc: '레벨당 탭 파워 +5%',
  buff_cps: '자동 수입 증폭',
  buff_cps_desc: '레벨당 자동 수입 +5%',
  buff_golden: '골든 확률',
  buff_golden_desc: '레벨당 골든 확률 +2%',
  buff_offline: '오프라인 효율',
  buff_offline_desc: '레벨당 오프라인 수익률 +5%',

  // Prestige 2 - Metaverse
  prestige2_title: '메타버스 환생',
  prestige2_coins: '메타버스 코인',
  prestige2_count: '2차 환생',
  prestige2_gain: '2차 환생 시',
  prestige2_execute: '2차 환생',
  prestige2_need: '블록체인 100개 이상 필요',
  prestige2_locked_title: '메타버스 환생',
  prestige2_locked_desc: '1차 환생 5회 + 블록체인 50개 필요',
  prestige2_locked_current: '현재',

  // Meta upgrades
  prestige2_meta_title: '메타버스 업그레이드',
  meta_auto_tap: '자동 탭봇', meta_auto_tap_desc: '1초마다 자동 탭 (탭 파워 100%)',
  meta_golden_boost: '골든 확률 증가', meta_golden_boost_desc: '골든 이벤트 출현 확률 2배',
  meta_offline_time: '오프라인 시간 연장', meta_offline_time_desc: '오프라인 보너스 8시간 -> 16시간',
  meta_milestone_boost: '마일스톤 부스트', meta_milestone_boost_desc: '마일스톤 x2 -> x3',
  meta_prestige_amplify: '환생 보너스 증폭', meta_prestige_amplify_desc: '블록체인 효과 1% -> 2%',

  // Prestige confirm
  prestige_confirm_title: '환생 확인',
  prestige_confirm_gain: '획득',
  prestige_confirm_after: '환생 후',
  prestige_confirm_warn_1: '코인, 생산기 초기화',
  prestige_confirm_keep_1: '블록체인, 업적 유지',
  prestige2_confirm_title: '2차 환생',
  prestige2_confirm_warn: '코인, 생산기, 블록체인 모두 초기화',
  prestige2_confirm_keep: '메타버스 코인, 업적 유지',

  // Achievement
  ach_title: '업적',
  ach_cat_production: '생산',
  ach_cat_generator: '생산기',
  ach_cat_prestige: '환생',
  ach_cat_click: '클릭',
  ach_cat_golden: '골든',
  ach_cat_special: '특수',

  // Achievement names (from config id)
  ach_ach_prod_1: '첫 코인', ach_ach_prod_1_desc: '코인 1 생산',
  ach_ach_prod_2: '백만장자', ach_ach_prod_2_desc: '코인 1M 생산',
  ach_ach_prod_3: '억만장자', ach_ach_prod_3_desc: '코인 1B 생산',
  ach_ach_prod_4: '조단위 부자', ach_ach_prod_4_desc: '코인 1T 생산',
  ach_ach_prod_5: '경단위 재벌', ach_ach_prod_5_desc: '코인 1Qa 생산',
  ach_ach_prod_6: '해단위 부호', ach_ach_prod_6_desc: '코인 1Qi 생산',
  ach_ach_prod_7: '자단위 거물', ach_ach_prod_7_desc: '코인 1Sx 생산',
  ach_ach_prod_8: '양단위 황제', ach_ach_prod_8_desc: '코인 1Sp 생산',
  ach_ach_prod_9: '구단위 신', ach_ach_prod_9_desc: '코인 1Oc 생산',
  ach_ach_prod_10: '간단위 초월자', ach_ach_prod_10_desc: '코인 1No 생산',
  ach_ach_prod_11: '정단위 창조주', ach_ach_prod_11_desc: '코인 1Dc 생산',
  ach_ach_prod_12: '재단위 절대자', ach_ach_prod_12_desc: '코인 1UDc 생산',
  ach_ach_gen_1: '스마트폰 마스터', ach_ach_gen_1_desc: '스마트폰 100개',
  ach_ach_gen_2: '노트북 마스터', ach_ach_gen_2_desc: '노트북 100개',
  ach_ach_gen_3: '데스크탑 마스터', ach_ach_gen_3_desc: '데스크탑 100개',
  ach_ach_gen_4: 'GPU 마스터', ach_ach_gen_4_desc: 'GPU 리그 100개',
  ach_ach_gen_5: 'ASIC 마스터', ach_ach_gen_5_desc: 'ASIC 채굴기 100개',
  ach_ach_gen_6: '농장 마스터', ach_ach_gen_6_desc: '채굴 농장 100개',
  ach_ach_gen_7: '데이터센터 마스터', ach_ach_gen_7_desc: '데이터센터 100개',
  ach_ach_gen_8: '양자컴퓨터 마스터', ach_ach_gen_8_desc: '양자컴퓨터 100개',
  ach_ach_gen_9: 'AI 마스터', ach_ach_gen_9_desc: 'AI 채굴봇 100개',
  ach_ach_gen_10: '위성 마스터', ach_ach_gen_10_desc: '위성 채굴기 100개',
  ach_ach_gen_11: '달 마스터', ach_ach_gen_11_desc: '달 채굴 기지 100개',
  ach_ach_gen_12: '은하 마스터', ach_ach_gen_12_desc: '은하 채굴 네트워크 100개',
  ach_ach_pres_1: '첫 환생', ach_ach_pres_1_desc: '1차 환생 1회',
  ach_ach_pres_2: '환생 마스터', ach_ach_pres_2_desc: '1차 환생 10회',
  ach_ach_pres_3: '환생 전설', ach_ach_pres_3_desc: '1차 환생 50회',
  ach_ach_pres_4: '블록체인 수집가', ach_ach_pres_4_desc: '블록체인 100개 보유',
  ach_ach_pres_5: '메타버스 입성', ach_ach_pres_5_desc: '2차 환생 1회',
  ach_ach_pres_6: '메타버스 거물', ach_ach_pres_6_desc: '2차 환생 5회',
  ach_ach_pres_7: '블록체인 제왕', ach_ach_pres_7_desc: '블록체인 500개 보유',
  ach_ach_pres_8: '환생 신', ach_ach_pres_8_desc: '1차 환생 100회',
  ach_ach_click_1: '클릭 초보', ach_ach_click_1_desc: '탭 100회',
  ach_ach_click_2: '클릭 마니아', ach_ach_click_2_desc: '탭 1,000회',
  ach_ach_click_3: '클릭 광', ach_ach_click_3_desc: '탭 10,000회',
  ach_ach_click_4: '클릭 신', ach_ach_click_4_desc: '탭 100,000회',
  ach_ach_click_5: '손목 파괴자', ach_ach_click_5_desc: '콤보 50 달성',
  ach_ach_click_6: '초당 10탭 달인', ach_ach_click_6_desc: '콤보 100 달성',
  ach_ach_golden_1: '골든 헌터', ach_ach_golden_1_desc: '골든 이벤트 10회 클릭',
  ach_ach_golden_2: '골든 마스터', ach_ach_golden_2_desc: '골든 이벤트 50회 클릭',
  ach_ach_golden_3: '골든 레전드', ach_ach_golden_3_desc: '골든 이벤트 200회 클릭',
  ach_ach_golden_4: '행운의 손', ach_ach_golden_4_desc: '럭키 골든 5회 획득',
  ach_ach_spec_1: '광고 후원자', ach_ach_spec_1_desc: '보상형 광고 10회 시청',
  ach_ach_spec_2: '광고 VIP', ach_ach_spec_2_desc: '보상형 광고 100회 시청',
  ach_ach_spec_3: '오프라인 부자', ach_ach_spec_3_desc: '오프라인 보너스 수령 10회',
  ach_ach_spec_4: '출석왕', ach_ach_spec_4_desc: '7일 연속 출석',
  ach_ach_spec_5: '완벽주의자', ach_ach_spec_5_desc: '모든 생산기 100개씩 보유',
  ach_ach_spec_6: '클릭 마스터', ach_ach_spec_6_desc: '코인 클릭 1,000회',
  ach_ach_spec_7: '속도광', ach_ach_spec_7_desc: '환생 없이 1시간 내 1B 생산',
  ach_ach_spec_8: '완주자', ach_ach_spec_8_desc: '모든 업적 달성',

  // Achievement reward types
  ach_reward_cps: '+{v}% 자동 수입',
  ach_reward_click: '+{v}% 탭',
  ach_reward_prestige: '환생',

  // Golden events
  golden_golden_coin: '골든 코인', golden_golden_coin_desc: '자동 수입 x777을 즉시 획득',
  golden_lucky_golden: '럭키 골든', golden_lucky_golden_desc: '15초간 자동 수입 x7',
  golden_click_frenzy: '클릭 프렌지', golden_click_frenzy_desc: '30초간 탭 파워 x10',
  golden_production_boost: '생산 부스트', golden_production_boost_desc: '30초간 모든 생산 x5',
  golden_mega_jackpot: '메가 잭팟', golden_mega_jackpot_desc: '현재 코인 x10',

  // Settings
  settings_title: '설정',
  settings_sound: '사운드',
  settings_bgm: 'BGM',
  settings_sfx: 'SFX',
  settings_language: '언어',
  settings_stats_title: '통계',
  settings_total_earned: '총 생산량',
  settings_total_taps: '총 탭',
  settings_max_combo: '최대 콤보',
  settings_golden_clicks: '골든 클릭',
  settings_prestige_count: '환생',
  settings_prestige2_count: '2차 환생',
  settings_play_time: '플레이 시간',
  settings_data_title: '데이터',
  settings_save: '수동 저장',
  settings_saved: '저장 완료!',
  settings_reset: '데이터 초기화',
  settings_reset_confirm: '정말 모든 데이터를 초기화하시겠습니까?',

  // Offline
  offline_title: '오프라인 보너스',
  offline_duration: '동안 채굴',
  offline_capped: '(최대치)',
  offline_claim: '수령하기',
  offline_ad_double: '광고 2배',

  // Common
  confirm: '확인',
  cancel: '취소',

  // Ad rewards
  ad_cps_boost: '자동 수입 30초 부스트',
  ad_offline_double: '오프라인 보너스 2배',
  ad_prestige_bonus: '환생 보너스 +50%',
  ad_timeskip: '2시간 타임스킵',
  ad_free_docs: '무료 문서',
  ad_golden_double: '골든 효과 2배',
  ad_start_boost: '시작 부스트 60초',
  ad_income_x5: '수입 10배',
  ad_tap_x10: '탭 파워 10배',
  ad_income_x5_desc: '15초간 수입 10배',
  ad_timeskip_desc: '2시간 즉시 생산',
  ad_tap_x10_desc: '15초간 탭 10배',
  ad_popup_income_title: '수입 x10 부스트',
  ad_popup_income_desc: '광고를 시청하면 15초간 모든 수입이 10배가 됩니다!',
  ad_popup_timeskip_title: '2시간 타임스킵',
  ad_popup_timeskip_desc: '광고를 시청하면 2시간 분량의 코인을 즉시 획득합니다!',
  ad_popup_tap_title: '탭 파워 x10',
  ad_popup_tap_desc: '광고를 시청하면 15초간 탭 파워가 10배가 됩니다!',
  ad_popup_watch: '시청하기',
  ad_popup_cancel: '닫기',

  // Achievement toast
  ach_toast: '달성!',

  // Missing keys (fix i18n key mismatches)
  action_daily: '일일보너스',
  gen_locked: '잠김',
  prestige_blockchain_owned: '보유 블록체인',
  prestige_reward_prefix: '환생 시 ',
  prestige_blockchain_unit: '블록체인',
  prestige_btn: '환생하기',
  prestige_need_1m: '총 생산량 1M 이상 필요',
  prestige_confirm_warn: '코인, 생산기 초기화',
  prestige_confirm_keep: '블록체인, 업적 유지',
  btn_cancel: '취소',
  prestige2_meta_coins: '메타버스 코인',
  prestige2_reward_prefix: '2차 환생 시 ',
  prestige2_meta_unit: '메타버스 코인',
  prestige2_btn: '2차 환생',
  prestige2_need_100: '블록체인 100개 이상 필요',
  prestige2_confirm_gain: '획득',
  prestige2_upgrades_title: '메타버스 업그레이드',
  ach_reward_tap: '탭',
  ach_reward_golden: '골든',
  ach_unlocked: '달성!',
  settings_stats: '통계',
  stats_total_earned: '총 생산량',
  stats_total_clicks: '총 탭',
  stats_max_combo: '최대 콤보',
  stats_golden_clicks: '골든 클릭',
  stats_prestige_count: '환생',
  stats_prestige2_count: '2차 환생',
  stats_play_time: '플레이 시간',
  settings_data: '데이터',
  toast_saved: '저장 완료!',
  settings_reset_title: '데이터 초기화',

  // Market sentiment
  market_price: '시세',
  manip_sns_hype: 'SNS 선동',
  manip_sns_hype_desc: '시세 상승 유도 (30% 역효과)',
  manip_influencer: '인플루언서',
  manip_influencer_desc: '안정적 시세 상승',
  manip_pump_dump: '펌프&덤프',
  manip_pump_dump_desc: '급등 후 폭락',

  // Dark Pool
  tab_darkpool: '다크풀',
  dp_title: 'Dark Pool',
  dp_total_bets: '총 베팅',
  dp_banner_soon: '다크풀 시작',
  dp_banner_live: '다크풀 진행 중!',
  dp_skip_cooldown: '광고 보고 바로 시작',
  dp_wins: '승리',
  dp_profit: '순수익',
  dp_next_round: '다음 라운드까지',
  dp_bet_hint: '보유 코인의 일부를 베팅하세요',
  dp_bet_coins: '코인 베팅',
  dp_available: '보유',
  dp_win_preview: '예상 보상',
  dp_real_coins: '코인',
  dp_tutorial_title: 'Dark Pool 안내',
  dp_tutorial_1: '\uD83C\uDFB2 Dark Pool은 보유 코인으로 경매에 참여하는 미니게임입니다.',
  dp_tutorial_2: '\uD83C\uDCCF 3개 코인 중 펌핑될 코인을 맞추면 베팅금 \u00D7 배율만큼 보상!',
  dp_tutorial_3: '\uD83D\uDCB0 코인의 1%~25%를 베팅할 수 있습니다. (업그레이드로 50%까지)',
  dp_tutorial_4: '\uD83D\uDCFA 광고를 보면 내부자 정보를 얻을 수 있습니다. (80% 정확도)',
  dp_betting: '베팅 진행중',
  dp_your_bet: '내 베팅',
  dp_get_insider: '내부자 정보',
  dp_place_bet: '베팅하기',
  dp_bet_placed: '베팅 완료',
  dp_waiting_result: '결과를 기다리는 중...',
  dp_revealing: '결과 공개중',
  dp_result: '결과',
  dp_you_won: '당첨!',
  dp_you_lost: '탈락...',
  dp_claim: '수령하기',
  dp_no_bet: '이번 라운드는 패스',
  dp_was_winner: '당첨!',
  dp_insider_title: '내부자 정보',
  dp_insider_hint: '가 오를 확률 80%! 예상',
  dp_insider_warn: '* 정보가 100% 정확하지 않을 수 있음',
  dp_insider_received: '내부자 정보를 획득했습니다!',

  // Onboarding
  onboarding_tap: '탭해서 코인을 채굴하세요!',
  onboarding_buy: '코인으로 생산기를 구매하세요!',

  // Golden event modal
  golden_event: '골든 이벤트',
  golden_claim_normal: '수령',
  golden_claim_ad: '광고x2',

  // Prestige ad
  prestige_ad_bonus: '광고+100%',

  // Ad boost
  golden_ad_income_x5: 'x10 부스트',

  // Exchange
  tab_exchange: '거래소',
  exchange_title: '코인 거래소',
  exchange_buy: '매수',
  exchange_sell: '매도',
  exchange_holdings: '보유',
  exchange_avg_price: '평단',
  exchange_profit: '수익',
  exchange_unlock: '해금',
  exchange_locked: '잠김',
  exchange_news: '뉴스',
  exchange_24h: '변동',

  // News events
  news_celeb_tweet: '⚡ 유명 인플루언서가 PIKA를 언급!',
  news_hack: '🔓 대형 거래소 해킹 발생!',
  news_nova_update: '🌟 NOVA 네트워크 대규모 업데이트!',
  news_whale_buy: '🐋 고래가 대량 매수!',
  news_regulation: '⚖️ 규제 강화 뉴스!',
  news_frog_burn: '🔥 FROG 대량 소각 이벤트!',
  news_bolt_partner: '⚡ BOLT 대기업 파트너십 체결!',
  news_star_listing: '🚀 STAR 대형 거래소 상장!',
  news_bull_market: '📈 강세장 시작 신호!',
  news_bear_market: '📉 약세장 경고!',
} as Record<string, string>;
